export default "/resource/img/logo.png"